import React, { useState } from "react";
import { EmailField, Form, ModalDialog, StringField, SubmitButton, Warning } from "@culturehq/components";

import { useProfile } from "app/context";
import { useDoor } from "app/hooks";
import { t, Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import ChqModalDialog from "./ChqModalDialog";

const CreateUserModal = ({ initialOpen, name, onCancel, onSuccess, isTrend }) => {
  const { profile: { organization, organizationAdmin, role } } = useProfile();
  const { open, onClose: onCloseModal } = useDoor(initialOpen);
  const [error] = useState();
  const [canInvite] = useState(
    organizationAdmin || role === "content_admin"
  );

  const handleClose = () => {
    onCloseModal();
    onCancel();
  };

  const onSubmit = ({ name, email, firstName, lastName }) => {
    onSuccess(name || `${firstName} ${lastName}`, email, firstName, lastName);
  };

  return (
    <ChqModalDialog entrance="zoomIn" open={open} onClose={handleClose} width="narrow">
      <ModalDialog.Heading onClose={handleClose}>
        <Trans>Add New User</Trans>
      </ModalDialog.Heading>
      <ModalDialog.Body>
        {!canInvite && (
          <>
            <Warning>
              <Trans>Unable to invite users. Please ask your admin.</Trans>
            </Warning>
            <br />
          </>
        )}

        {canInvite && (
          <>
            <Form onSubmit={onSubmit} initialValues={{ name, firstName: name }}>
              {error && <ErrorMessage error={error} />}
              <EmailField name="email" required>
                <Trans>Email *</Trans>
              </EmailField>
              {organization.firstNameLastNameEnabled ? (
                <>
                  <StringField name="firstName" required>
                    <Trans>First Name *</Trans>
                  </StringField>
                  <StringField name="lastName" required>
                    <Trans>Last Name *</Trans>
                  </StringField>
                </>
              ) : (
                <StringField name="name" required>
                  <Trans>Name *</Trans>
                </StringField>
              )}
              <SubmitButton primary fillParent>
                {submitting => (submitting ? t("Submitting...") : t("Add User"))}
              </SubmitButton>
            </Form>

            <p>
              <br />
              <i>
                <Trans>
                  Note: This user will be created once you send this notification
                  to {isTrend ? "join this trend." : "answer this prompt."}
                </Trans>
              </i>
            </p>
          </>
        )}
      </ModalDialog.Body>
    </ChqModalDialog>
  );
};

export default CreateUserModal;
